<template>
  <div class="bottom-sheet" :class="sheetActive ? 'active' : ''" ref="sheet">
    <div class="backdrop sheet-close"></div>
    <div class="content">
      <slot></slot>

      <div class="footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BottomSheet',
    props: {
      active: {
        type: Boolean,
        default: false,
      }
    },
    watch: {
      active(newValue) {
        this.sheetActive = newValue;
      }
    },
    data() {
      return {
        sheetActive: this.active,
      }
    },
    mounted() {
      const sheet = this.$refs.sheet;
      const closeBtns = sheet.querySelectorAll('.sheet-close');

      closeBtns.forEach(btn => btn.addEventListener('click', e => {
        this.sheetActive = false;
        this.$emit('close', e)
      }));
    }
  }
</script>

<style lang="scss" scoped>
.bottom-sheet {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  pointer-events: none;
  transition: $transition-mid-in-out;


  .backdrop {
    transition: inherit;
    background-color: transparent;
    
    @supports ((backdrop-filter: blur(20px))) {
      backdrop-filter: blur(0px);
    }
  }

  .content {
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: .5rem 1rem;
    transition: inherit;
    background-color: white;
    transform: translateY(100%);

    @supports ((backdrop-filter: blur(20px))) {
      backdrop-filter: blur(8px);
      background-color: #fffffff9;
    }
    
    .footer {
      padding: .75rem 0 .5rem;
      text-align: right;
    }

    @media only screen and (min-width: 600px) {
      width: 50%;
      left: 50%;
      transform: translate(-50%, 100%);

      border-radius: 5px;
    }
  }


  &.active {
    pointer-events: all;

    .backdrop {
      background-color: #000000a9;

      @supports ((backdrop-filter: blur(20px))) {
        backdrop-filter: blur(8px);
      }
    }

    .content {
      transform: translateY(0);

      @media only screen and (min-width: 600px) {
        transform: translate(-50%, -1rem);
      }
    }
  }
}
</style>

<style lang="scss">
$border: 1px solid #ffffff39;
.theme-dark {
  .bottom-sheet .content {
    background-color: transparentize($dark-light-color-raw, 0.5) !important;

    @supports ((backdrop-filter: blur(20px))) {
      backdrop-filter: blur(50px);
      border-top: $border;

      @media only screen and (min-width: 600px) {
        border: $border;
      }
    }
  }
}
</style>
